import * as React from 'react';

const Documents: React.FC<{}> = () => {
  return <></>;
};

export default Documents;
